import React from "react";
import { Box, Typography, FormControlLabel, Checkbox, Grid } from "@mui/material";
import { Flasher } from "../../models/signalSources/flasher.ts";

interface Props {
  data: Flasher;
  onChange: (updated: Flasher) => void;
}

const FlasherForm: React.FC<Props> = ({ data, onChange }) => {
  const update = (field: keyof Flasher, value: any) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Mikrocontroller Flasher</Typography>
      <Box mt={2} />
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.stlink1.enable}
                        onChange={(e) => update("stlink1", { ...data.stlink1, enable: e.target.checked })}
                    />
                    }
                    label="ST Link Nr. 1"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.stlink2.enable}
                        onChange={(e) => update("stlink2", { ...data.stlink2, enable: e.target.checked })}
                    />
                    }
                    label="ST Link Nr. 2"
                />
            </Grid>
        </Grid>
    </Box>
  );
};

export default FlasherForm;
